<div class="bones-document"
     [style.background-image]="backgroundImage"
     (click)="documentClicked()"
     (drop)="onDrop($event)" (dragover)="allowDrop($event)">
  <input type="file" #fileInput (change)="fileSelected()" />
  <span *ngIf="textOverlay">{{textOverlay}}</span>
  <span class="bones-document-label" *ngIf="tnLabel">{{tnLabel}}</span>
</div>
